import { ISingleIdParams } from '../types/actionParams';
import { Request } from './Request';
import { FlowDraftAllowedActions } from '../types/FlowDraftAllowedActions';

export class GetFlowDraftActionsRequest extends Request<ISingleIdParams, FlowDraftAllowedActions> {
 constructor(id: string) {
   super('getFlowDraftActions', { id: id });
 }
}